import React from 'react'

import { useLocation } from 'react-router-dom'

import { Section } from '../components/ContainerSection'
import { Spacer } from '../components/global'
import ProfileView from '../components/profile/ProfileView'
import { useUser } from '../context'
import { AnyProfile } from '../types'

// TODO: Limpiar archivo
const ProfilePage = () => {
  const { user, userRole, loadingUser } = useUser()
  // const [profile, setProfile] = useState<Student | Profesor | null>(user)
  const { pathname } = useLocation()

  if (loadingUser || !user) {
    return (
      <Section
        title="Datos Personales"
        childrenClass="full-space-section"
        style={{
          overflowY: 'scroll',
          maxHeight: `calc(100vh - ${
            userRole === 'professor' ? '250' : '290px'
          })`,
        }}
      >
        <div>Loading...</div>
      </Section>
    )
  }

  return (
    <Section
      title="Datos Personales"
      childrenClass="full-space-section"
      style={{
        overflowY: 'scroll',
        maxHeight: `calc(100vh - ${userRole !== 'admin' ? '250px' : '290px'})`,
      }}
    >
      <ProfileView
        initialProfile={user as AnyProfile}
        isNewUser={pathname === '/nuevo-usuario'}
      />

      <Spacer height={32} />
    </Section>
  )
}

export default ProfilePage
